import { Info } from 'lucide-react';
import { useState } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * The original "i" hint next to page and section titles. Never use it on the shared report pages:
 * their tests allow only the breakdown toggles and the downloads (sprint-05 F66, sprint-06 F71, sprint 18).
 */
export function InfoHint({ text, side = 'top' }: { text: string; side?: 'top' | 'right' | 'bottom' | 'left' }): JSX.Element {
  const [open, setOpen] = useState(false);
  return (
    <Tooltip open={open} onOpenChange={setOpen}>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={text}
          title={open ? undefined : text}
          className="shrink-0 rounded leading-none text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <Info className="h-3.5 w-3.5" aria-hidden="true" />
        </button>
      </TooltipTrigger>
      <TooltipContent side={side} sideOffset={6} collisionPadding={8} arrow>
        {text}
      </TooltipContent>
    </Tooltip>
  );
}
